import React, { useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import TextInput from '../../components/form/TextInput';
import PasswordInput from '../../components/form/PasswordInput';
import CheckBox from '../../components/form/CheckBox';
import Button from '../../components/form/Button';
import { useNavigate } from 'react-router-dom';
import LangSwitcher from '../../components/shared/LangSwitcher';
import FormContainer from '../../containers/FormContainer';
import usePageTitle from '../../helpers/usePageTitle';

const Login = ({ handleLogin, isLoginLoading, loginError, changeLanguage }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const [loginForm, setLoginForm] = useState({
    username: '',
    password: '',
    agreeToTerms: false,
  });

  const handleCheckAgreeToTerms = (e) => {
    setLoginForm({ ...loginForm, agreeToTerms: e.target.checked });
  }

  const goToSignUp = () => {
    navigate(`/${i18n.language}/sign-up`, { replace: true });
  }

  usePageTitle("login");

  return (
    <div className='min-h-screen bg-white'>
      <div className='max-w-[420px] mx-auto px-[15px] pt-[64px] pb-[100px]'>
        <img src="/assets/images/logo.svg" alt="ABMFY" className='h-[64px] mb-[48px]' />
        <div className='text-tprimary text-[28px] font-[700] leading-[34px] mb-[32px] rubik'>{t('sign_in')}</div>
        <FormContainer onSubmit={()=>handleLogin({email: loginForm?.username, password: loginForm?.password})} isLoading={isLoginLoading} error={loginError}>
          <div>
            <TextInput label={t('username')} placeholder={t('username')} value={loginForm.username} onChange={(e) => setLoginForm({ ...loginForm, username: e.target.value })} />
            <PasswordInput label={t('password')} placeholder={t('password')} value={loginForm.password} onChange={(e) => setLoginForm({ ...loginForm, password: e.target.value })} />
            <CheckBox label={t('agree_to_terms')} checked={loginForm.agreeToTerms} onChange={handleCheckAgreeToTerms} labelClassName='block text-tprimary font-[400] text-[14px] leading-[18px] rubik cursor-pointer user-select-none mt-[-2px] mb-[32px]' />
            <div className='flex justify-center gap-x-[16px]'>
              <div className='w-[50%]'>
                <Button onClick={()=>handleLogin({email: loginForm?.username, password: loginForm?.password})} disabled={!loginForm.agreeToTerms || loginForm.username.toString().length === 0 || loginForm.password.toString().length === 0} label={t('login')} />
              </div>
              <div className='w-[50%]'>
                <Button onClick={goToSignUp} buttonStyle={'gray'} label={t('sign_up')} />
              </div>
            </div>
            <div className='text-[start] cursor-pointer mt-[24px]'>
              <div className='inline-block text-tprimary text-[14px] font-[500] leading-[18px] rubik'>
                {t('login_with_google')}
              </div>
              <img src="/assets/images/google.svg" alt="login with google" className='w-[40px] h-[40px] inline-block align-middle ms-[14px]' />
            </div>
          </div>
          <LangSwitcher i18n={i18n} changeLanguage={changeLanguage} />
        </FormContainer>
      </div>
    </div>
  );
};

export default Login;
